export enum ExternalTool {
    HeatPumpPlanner = 'HeatPumpPlanner',
    PhotovoltaicPlanner = 'PhotovoltaicPlanner',
    QuoteAssist = 'QuoteAssist',
    PartnerShop = 'PartnerShop',
    ViGuide = 'ViGuide',
    VitoAirPlanner = 'VitoAirPlanner',
    Air2AirPlanner = 'Air2AirPlanner'
}
